export default __webpack_public_path__ + "assets/8e90bb6fb30cde3b6afa4555813288d2.jpeg";